import dayjs from 'dayjs';

export interface IKr {
  id?: string;
  parentObjectiveIds?: string[];
  accountableId?: string;
  projectId?: string | null;
  workGroupId?: string | null;
  purpose?: string | null;
  contribution?: number | null;
  informEmails?: string | null;
  tags?: string | null;
  planTags?: string | null;
  IsDeleted?: boolean;
}

export const defaultValue: Readonly<IKr> = {
  IsDeleted: false,
};
